import { atom } from "recoil";
import ILanguage from "../Interfaces/ILanguage";
import { sv } from "../Lang/sv";

export const LanguageAtom = atom<ILanguage>({
  key: 'languageAtom', 
  default: sv, 
});
